/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable no-cond-assign */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-explicit-any */
// This is a port of the clsx library: https://github.com/lukeed/clsx

type ClassValue = string | number | boolean | undefined | null | ClassArray | ClassDictionary;

type ClassDictionary = {
  [key: string]: any;
};

type ClassArray = Array<ClassValue>;

function toVal(mix: ClassValue): string {
  let k: number;
  let y: string;
  let str = '';

  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (typeof mix === 'object' && mix !== null) {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if ((y = toVal(mix[k]))) {
            // eslint-disable-next-line no-unused-expressions
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      Object.keys(mix).forEach(key => {
        if (mix[key]) {
          str && (str += ' ');
          str += key;
        }
      });
    }
  }

  return str;
}

/**
  clsx
  A tiny (228B) utility for constructing className strings conditionally.
  Also serves as a faster & smaller drop-in replacement for the classnames module.

  ### Strings (variadic)
  clsx('foo', true && 'bar', 'baz');
  // 'foo bar baz'

  ### Objects
  clsx({ foo:true, bar:false, baz:isTrue() });
  // 'foo baz'

  ### Objects (variadic)
  clsx({ foo:true }, { bar:false }, null, { '--foobar':'hello' });
  // 'foo --foobar'

  ### Arrays
  clsx(['foo', 0, false, 'bar']);
  // 'foo bar'

  ### Arrays (variadic)
  clsx(['foo'], ['', 0, false, 'bar'], [['baz', [['hello'], 'there']]]);
  // 'foo bar baz hello there'

  ### Kitchen sink (with nesting)
  clsx('foo', [1 && 'bar', { baz:false, bat:null }, ['hello', ['world']]], 'cya');
  // 'foo bar hello world cya'
 */
export function clsx(...args: ClassValue[]): string {
  let i = 0;
  let tmp: ClassValue;
  let x: string;
  let str = '';
  while (i < args.length) {
    if ((tmp = args[i++])) {
      if ((x = toVal(tmp))) {
        str && (str += ' ');
        str += x;
      }
    }
  }
  return str;
}
